import React, { type FunctionComponent } from 'react';
// TODO: There is no "Bubble" export in @wix/wix-base-ui
// @ts-expect-error
import { Bubble } from '@wix/wix-base-ui';
import { cx } from '#packages/util';

import type { PositionStyle } from './dropDownTypes';

const DEFAULT_ARROW_STYLE: PositionStyle = {
  left: 'calc(50% - 8px)',
  top: '4px',
};

const DEFAULT_CONTENT_STYLE: PositionStyle = {
  left: '0',
  top: '12px',
};

interface DropDownPanelProps {
  className?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  maxWidth?: number;

  arrowAlignment?: 'right' | 'top';
  panelPositionStyle: PositionStyle;
  arrowPositionStyle?: PositionStyle;
  arrowStyleOverrides?: React.CSSProperties;
  contentPositionStyle?: PositionStyle;
  contentStyleOverrides?: React.CSSProperties;
  children?: React.ReactNode;

  nodeRef?: (ref: Node) => void;
}

const DropDownPanel: FunctionComponent<DropDownPanelProps> = (props) => (
  <div
    className={cx('top-bar-drop-down-panel', props.className)}
    style={props.panelPositionStyle}
  >
    <Bubble
      dataHook="top-bar-drop-down-tooltip"
      className="tooltip"
      arrowAlignment={props.arrowAlignment ?? 'top'}
      arrowStyle={{
        ...props.arrowPositionStyle,
        ...props.arrowStyleOverrides,
      }}
      contentStyle={{
        ...props.contentPositionStyle,
        ...props.contentStyleOverrides,
      }}
      maxWidth={props.maxWidth}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      onLayoutChange={props.nodeRef}
    >
      <span
        className="top-bar-drop-down-panel-shutter"
        style={{ height: props.contentPositionStyle.top }}
      />
      {props.children}
    </Bubble>
  </div>
);

DropDownPanel.displayName = 'DropDownPanel';
DropDownPanel.defaultProps = {
  maxWidth: 750,
  arrowAlignment: 'top',
  arrowPositionStyle: DEFAULT_ARROW_STYLE,
  arrowStyleOverrides: {},
  contentPositionStyle: DEFAULT_CONTENT_STYLE,
};

export default DropDownPanel;
